export default "__VITE_ASSET__803ba91e__"